export default __webpack_public_path__ + "static/media/location-gradient.cf90bc71.svg";